import {
  FeatureLevelPermissions,
  Permissions
} from '@/models/UserPermissions.model';

export interface Endpoint {
  name: string;
  url: string;
  method: 'GET' | 'POST' | 'PUT';
  permissions: Permissions[];
  bodyTemplate?: string;
}

export interface EndpointToolFormValues {
  endpoint: Endpoint;
  payload: string;
}

export const endpoints: Endpoint[] = [
  {
    bodyTemplate:
      '{\n' + '    "participantId": "",\n' + '    "planId": ""\n' + '}',
    method: 'POST',
    name: 'Add Participant',
    permissions: [FeatureLevelPermissions.WRITE_PROD_SUPPORT_ENDPOINTS_MAX],
    url: '/endpoint-tool/surpas/employee'
  },
  {
    bodyTemplate: '{\n' + '    "participantId": ""\n' + '}',
    method: 'PUT',
    name: 'Sync Participant',
    permissions: [FeatureLevelPermissions.WRITE_PROD_SUPPORT_ENDPOINTS_MAX],
    url: '/endpoint-tool/surpas/employee'
  },
  {
    bodyTemplate:
      '{\n' + '    "sponsorId": "",\n' + '    "isOnboarding": "false"\n' + '}',
    method: 'PUT',
    name: 'Sync Sponsor',
    permissions: [FeatureLevelPermissions.WRITE_PROD_SUPPORT_ENDPOINTS_MAX],
    url: '/endpoint-tool/surpas/employer'
  },
  {
    bodyTemplate: '{\n' + '    "payrollSetupId": "",\n' + '}',
    method: 'PUT',
    name: 'Sync Bank ccount',
    permissions: [FeatureLevelPermissions.WRITE_PROD_SUPPORT_ENDPOINTS_MAX],
    url: '/endpoint-tool/surpas/employer/bank-account'
  },
  {
    bodyTemplate:
      '{\n' +
      '    "fileNameExp": "MFC2_MASCIPEXT_CTRET_${today}.txt",\n' +
      '    "fileType": "cip"\n' +
      '}',
    method: 'POST',
    name: 'Ingest Surpas Employee file',
    permissions: [FeatureLevelPermissions.WRITE_PROD_SUPPORT_ENDPOINTS_MAX],
    url: '/endpoint-tool/surpas/ingestion/employee'
  },
  {
    bodyTemplate: '{\n' + '    "executionIds": []\n' + '}',
    method: 'POST',
    name: 'Retry Subaccounting Executions',
    permissions: [FeatureLevelPermissions.WRITE_PROD_SUPPORT_ENDPOINTS_MAX],
    url: '/endpoint-tool/subaccounting/execution/retry'
  },
  {
    method: 'GET',
    name: 'Test Get Participant Accounts',
    permissions: [FeatureLevelPermissions.WRITE_PROD_SUPPORT_ENDPOINTS_SHARED],
    url: '/endpoint-tool/participants/{participantId}/accounts'
  },
  {
    method: 'GET',
    name: 'Get Ingestion Activities',
    permissions: [FeatureLevelPermissions.WRITE_PROD_SUPPORT_ENDPOINTS_MAX],
    url: '/action-center/bulk/employer-list'
  }
];
